import React from 'react';
import Field from '../fields/Field';
import LocalizedMessage from 'react-l10n';
import { getTranslation } from '../../lang/main';
import { getFieldStatusProps } from '../../selectors/defaultSelectors';

const FORM_LABEL = {
    PurchaseOrderNumber: getTranslation('FIELD.PURCHASE_ORDER_NUMBER'),
};

function CheckoutPurchaseOrderNumber(props) {
    const {
        isLoading,
        formData,
        handleFormUpdate,
        fieldRefs,
        fieldStatus,
        // handleFormSubmission,
        // appliedDiscountCode,
    } = props;

    return (
        <React.Fragment>
            <div className='card__header'>
                <h5 className='heading--lv5 heading'>
                    <LocalizedMessage
                        id={'CHECKOUT.PURCHASE_ORDER_NUMBER.HEADING'}
                    />
                </h5>
            </div>
            <div className='vspace'>
                <Field
                    required={true}
                    ref={(r) => (fieldRefs.PurchaseOrderNumber = r)}
                    isLoading={isLoading}
                    label={FORM_LABEL['PurchaseOrderNumber']}
                    animatedLabel={FORM_LABEL['PurchaseOrderNumber']}
                    name='PurchaseOrderNumber'
                    value={formData.PurchaseOrderNumber || ''}
                    onChange={e => {
                        e.target.value = e.target.value.substr(0, 17);
                        handleFormUpdate(e);
                    }}
                    // onBlur={handleFormSubmission}
                    {...getFieldStatusProps(fieldStatus, 'PurchaseOrderNumber')}
                    tooltip={
                        <>
                            <LocalizedMessage
                                id={
                                    'FIELD.PURCHASE_ORDER_NUMBER_TOOLTIP'
                                }
                            />
                        </>
                    }
                />
                {/* <span
                    className='field-instruction'
                    style={{ opacity: appliedDiscountCode ? 1 : 0 }}
                >
                    <strong>Applied Discount:</strong>{' '}
                    <u>{appliedDiscountCode}</u>
                </span> */}
            </div>
        </React.Fragment>
    );
}

export default CheckoutPurchaseOrderNumber;
